import { render, staticRenderFns } from "./RecipeListingsSectionModule.vue?vue&type=template&id=24c6c482&"
import script from "./RecipeListingsSectionModule.vue?vue&type=script&lang=js&"
export * from "./RecipeListingsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports